import { createAsyncThunk } from '@reduxjs/toolkit';
import { tokenStorage } from 'redux/slices/baseApi/token-storage';

export const logout = createAsyncThunk('profile/logout', () => {
  window.localStorage.removeItem('redux-user');
  window.localStorage.removeItem('redux-currentRole');
  tokenStorage.clearTokens();
});
